module.exports = __webpack_public_path__ + "img/30.927949af.gif";